// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import './theme/css/cloud-admin.min.css';
import './theme/css/themes/default.min.css';
import './theme/font-awesome/css/font-awesome.min.css';
import './theme/js/bootstrap-daterangepicker/daterangepicker-bs3.css';
import './theme/js/uniform/css/uniform.default.min.css';
import './theme/css/animatecss/animate.min.css';
import './theme/js/datatables/media/css/jquery.dataTables.min.css';
import './theme/js/datatables/media/assets/css/datatables.min.css';
import './theme/js/datatables/extras/TableTools/media/css/TableTools.min.css';
import './index.css';
import './jquery-datatables-setup';

import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './azue_config';
export const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}
msalInstance.enableAccountStorageEvents();
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <Auth0Provider
            domain={process.env.REACT_APP_OFA_DOMAIN || ''}
            clientId={process.env.REACT_APP_OFA_CLIENT || ''}
            authorizationParams={{
                redirect_uri: process.env.REACT_APP_OFA_REDIRECT || 'http://127.0.0.1:8081',
                connection: 'User-Prod',
            }}
        >
            <App instance={msalInstance} />
        </Auth0Provider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
